import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Navbar from '../../Navbar';
import { profileActions } from '../../../actions';
import { useLoggedUser } from '../../../hooks/useLoggedUser';
import { invalidateRequestCache, createRequestCacheKey } from '../../../helpers/requestCache';

const ScoreBoard = () => {
    const dispatch = useDispatch();
    const [scoreboard, setScoreBoard] = useState(null);
    const loggedUser = useLoggedUser();

    useEffect(() => {
        if (!loggedUser?.data?.ClassID) return;

        // Clear cached scoreboard so we always fetch fresh data on each redirect
        invalidateRequestCache([
            createRequestCacheKey('profile', 'scoreboard', loggedUser.data.ClassID),
        ]);

        dispatch(profileActions.fetchScoreBoard(loggedUser.data.ClassID))
            .then((response) => {
                setScoreBoard(response.data);
            })
            .catch((error) => {
                console.error('Error: ', error);
            });
    }, [dispatch, loggedUser.data.ClassID]);

    return (
        <React.Fragment>
            <div className="continer-fluid terms-page">
                <Navbar />
                <div className="content" id="content">
                    <div className="d-flex justify-content-center align-items-center flex-column  ">
                        <h2 className="scoreboard-h main-heading-top">Score Board</h2>
                        <div className="tableWrap ">
                            <table className="w-100 text-center score-table">
                                <thead>
                                    <tr>
                                        <th className="b-font score-th">Rank</th>
                                        <th className="b-font  score-th">Player</th>
                                        <th className="b-font  score-th">Score</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {scoreboard?.map((score, index) => (
                                        <tr key={score.StudentProfileID ?? `score-${index}`}>
                                            <td className="b-font score-td">{index + 1}</td>
                                            <td className="b-font score-td left-align">{score.UserName}</td>
                                            <td className="b-font score-td">{score.Score}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ScoreBoard;
